
import CreateMedia from 'webutils/media/create-media'

export default CreateMedia;